import styled, { createGlobalStyle } from "styled-components";

export const supportDeviceSize = 1080;

export const device = {
  mobile: `max-width: 769px`,
};

export const GlobalStyle = createGlobalStyle`
html {
font-size: 62.5%; // 1rem = 10px 로 변경 한 것
// 참고링크 = https://stackoverflow.com/questions/68790660/setting-root-font-size-not-affecting-rem-units-in-safari-for-margin-padding-et
// 128px => 12.8rem , 4px => 0.4rem 가능!

    /* @media all and (max-width: ${supportDeviceSize}px) {
        font-size: 31.25%;
    } */
}

* {
  margin: 0;
  padding:0;
  box-sizing: border-box;
  font-family: 'SUIT Variable', sans-serif;
}


body {
    background: white;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-x: hidden;
}

button {
    border : none;
    outline : none;
    background-color : transparent;
    cursor : pointer;
    margin: 0;
    padding: 0;
}

input {
  outline: none;
}

ul {
  all: unset;
}
`;

export const Title = styled.div`
  color: #1c1d1f;
  font-size: 2.8rem;
  font-weight: 800;
  line-height: 150%;

  @media all and (${device.mobile}) {
    font-size: 1.8rem;
    font-weight: 700;
  }
`;
